// extracted by mini-css-extract-plugin
export default {"base":"vp_zSOaL","eyebrow":"vp_s7pgN","title":"vp_EY2gq","lead":"vp_BxvaP","alignCenter":"vp_VM4Lb"};